<div class="relative isolate flex h-full w-full max-lg:flex-col lg:overflow-hidden">
  <ng-container *ngIf="isLoggedIn">
    <app-side-nav></app-side-nav>
  </ng-container>
  <main [ngClass]="isLoggedIn ? 'lg:pl-32' : ''" class="flex flex-1 flex-col lg:min-w-0 overflow-hidden">
    <ng-container *ngIf="isLoggedIn">
      <app-header></app-header>
    </ng-container>
    <div [ngClass]="isLoggedIn ? 'h-full w-full lg:overflow-hidden' : ''" class="">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>

<!-- <div *ngIf="false" class="flex h-full overflow-hidden">
  <ng-container *ngIf="isLoggedIn">
    <app-side-nav></app-side-nav>
  </ng-container>
  <div class="flex flex-1 flex-col overflow-hidden">
    <ng-container *ngIf="isLoggedIn">
      <app-header></app-header>
    </ng-container>
    <div class="flex flex-1 items-stretch overflow-hidden">
      <main class="flex-1 overflow-y-auto">
        <router-outlet> </router-outlet>
      </main>
    </div>
  </div>
</div> -->

<ngx-ui-loader
  [fgsColor]="'#5046E4'"
  [pbColor]="'#5046E4'"
  [fgsType]="'fading-circle'"
  [fgsPosition]="'top-left'"
></ngx-ui-loader>


